import React, { FC, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import EWallet from "../../../components/EWallet/EWallet";
import Header from "../../../components/Header/Header";
import eWalletInfo from "../../../interfaces/ewallet-info";
import validator from "../../../utils/validator";
import addCommas from "../../../utils/amountFormat";
import styles from "./EwalletPaymentReview.module.scss";
import useAddTransaction from "../../../hooks/useAddTransaction";
import analyticsService from "../../../services/analytics/analyticsService";

function EwalletPaymentReview(props: any) {
  const navigate = useNavigate();
  const location = useLocation();
  const [addTransaction] = useAddTransaction();
  const [status, setStatus] = useState<number>(200);

  const [payAmt, setPayAmt] = useState({
    value: "",
    error: "",
    touched: false,
  });

  const handleInput = (type: string, input: any, field: object) => {
    const newField: any = { ...field };
    newField[type] = input;
    return newField;
  };

  const {
    amount,
    grade,
    id,
    studentFirstName,
    studentLastName,
    teacherFirstName,
    teacherLastName,
  } = location.state as eWalletInfo;

  const item: eWalletInfo = {
    amount,
    grade,
    id,
    studentFirstName,
    studentLastName,
    teacherFirstName,
    teacherLastName,
  };

  let dumble = new analyticsService();

  const enoughFunds = () => {
    if (parseFloat(payAmt.value.replaceAll(",", "")) > item.amount) {
      setPayAmt(handleInput("error", "Not enough funds", payAmt));
      dumble.initDumblePage("Payment Portal:eWallet:Payment Amount Error");
    } else{
      dumble.initDumblePage("Payment Portal:eWallet:Payment Amount")
    }
  };

  useEffect(() => {
    setPayAmt(
      handleInput(
        "error",
        validator(payAmt.value, ["required"]),
        payAmt
      )
    );
    enoughFunds();
  }, [payAmt.value]);

  const displayError = (input: any) => {
    if (input.error !== "") {
      return <div className={styles.errorMessage}>{input.error}</div>;
    }
    return null;
  };

  const submitTransaction = async (payload: any) => {
    const { data, error } = await addTransaction(id, payload);
    if (error) {
      setStatus(error.status);
      console.log(error);
      if (error.status === 403) navigate("/");
    } else if (data != null) {
      setStatus(200);
      dumble.setDumbleEPaymentCartInfo("Payment Portal:eWallet:Payment Confirmation", "eWallet", payAmt.value, "some tax", item.id.toString(), data.id);
      navigate("/success", { state: { toasterType: "ewallet" } });
    }
  };

  const ewalletPaymentSuccess = () => {
    setPayAmt(handleInput("touched", true, payAmt));
    if (payAmt.error == "") {
      const transactionInfo = {
        type: "SALE",
        amount: payAmt.value,
        note: "ewallet sale",
      };
      submitTransaction(transactionInfo);
    }
  };

  return (
    <div
      className={styles.EwalletPaymentReview}
      data-testid="EwalletPaymentReview"
    >
      <Header name="Input Payment Amount" redirect="/ewalletPayment.html" />
      <div className={styles.EwalletWrapper}>
        <div className={styles.responsive}>
          <div className={styles.ewallet}>
            <EWallet className={styles} item={item} />
          </div>
          <label htmlFor="paymentAmt" className={styles.payAmt}>
            Payment Amount
            <input
              type="text"
              value={`$ ${payAmt.value}`}
              maxLength={10}
              onChange={(e) =>
                setPayAmt(
                  handleInput(
                    "value",
                    addCommas(e.target.value),
                    payAmt
                  )
                )
              }
              onBlur={() => setPayAmt(handleInput("touched", true, payAmt))}
              aria-label="paymentAmt"
              id="paymentAmt"
            />
            {payAmt.error !== "" && payAmt.touched ? displayError(payAmt) : null}
            {payAmt.error === "" && status !== 200 ? (
              <div className={styles.errorMessage}>
                Service is down. Please try again later.
              </div>
            ) : null}
          </label>
        </div>
        <button
          type="submit"
          onClick={ewalletPaymentSuccess}
          id="submitButton"
          disabled={false}
        >
          SUBMIT PAYMENT
        </button>
      </div>
    </div>
  );
}

export default EwalletPaymentReview;
